import { Injectable } from "@angular/core";

/**
 * Serviço utilitário para animação de elementos do DOM.
 */
@Injectable({ providedIn: "root" })
export class HtmlElementAnimationService {

    /**
     * Anima o elemento para ser exibido na tela de forma sutil, aumentando a opacidade do mesmo.
     *
     * @param element - Elemento que deverá ser animado.
     * @param duration - Duaração da animação.
     * @param onFinishCallback - Callback a ser executado ao finalizar a animação.
     */
    opacityIn(element: HTMLElement, duration: number = 200, onFinishCallback?: Function) {
        const animation = element.animate(
            [
                { opacity: 0, transform: "scale(0.95)" },
                { opacity: 1, transform: "scale(1)" }
            ],
            { duration, easing: "ease-in" }
        );

        if (onFinishCallback) {
            animation.onfinish = onFinishCallback();
        }
    }

    /**
     * Anima o elemento para ser removido da tela de forma sutíl, diminuindo a opacidade do mesmo.
     *
     * @param element - Elemento que deverá ser animado.
     * @param duration - Duaração da animação.
     * @param onFinishCallback - Callback a ser executado ao finalizar a animação.
     */
    opacityOut(element: HTMLElement, duration: number = 200, onFinishCallback?: Function) {
        const animation = element.animate(
            [
                { opacity: 1, transform: "scale(1)" },
                { opacity: 0, transform: "scale(0.95)" }
            ],
            { duration, easing: "ease-out" }
        );

        if (onFinishCallback) {
            animation.onfinish = onFinishCallback();
        }
    }
}
